import store from "@/store";
import nativeHandlerService from "@/services/nativeHandler";

export const goToDbsApp = async (park) => {
  if (store.getters["common/device"] == "BROWSER") {
    alert(
      "ncOpenDbsApp :>> " +
        park.GeoPoint.lati_d +
        ", " +
        park.GeoPoint.longi_d +
        ", " +
        park.Station.code.split(".")[1]
    );
  } else {
    nativeHandlerService.ncOpenDbsApp(
      park.GeoPoint.lati_d,
      park.GeoPoint.longi_d,
      park.Station.code.split(".")[1]
    );
  }
};
